import { Button, DownloadIcon } from 'canoe';
import React from 'react';

import { useDownloadAnalyticsQuery } from './useDownloadAnalyticQuery';

interface Props {
  id: string;
  query: Record<string, string | null>;
}

export const DownloadTableButton = ({ id, query }: Props) => {
  const { download, isLoading } = useDownloadAnalyticsQuery(query);
  const onClick = async () => {
    const url = await download({ queryId: id });
    window.open(url);
  };

  return (
    <Button
      appearance="outline"
      variant="secondary"
      icon={DownloadIcon}
      loading={isLoading}
      onClick={onClick}
    >
      Download Data
    </Button>
  );
};
